import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, ChevronRightIcon } from 'lucide-react';
import { landingBImages } from '../../data/landingBVisual';

/**
 * The closing statement. Photography carries the emotion; the panel holds the
 * two things a visitor can actually do next, and nothing else.
 */
export function FinalCTAB() {
  return <section className="mx-auto max-w-[88rem] px-4 pb-14 sm:px-8" data-id="element-2501" data-mp="7mej8ok3effe">
      <div className="relative isolate overflow-hidden rounded-panel bg-brand-900" data-id="element-2502" data-mp="156r06cdqq1jz">
        <img src={landingBImages.ctaGroup} alt="A group of students together on campus, looking at a phone" loading="lazy" decoding="async" className="absolute inset-y-0 right-0 -z-10 h-full w-full object-cover object-right lg:w-2/3" data-id="element-2503" data-mp="10a0jpny0x3y1" />
        <div aria-hidden className="absolute inset-0 -z-10 bg-gradient-to-r from-brand-900 via-brand-900/90 to-brand-900/30" data-id="element-2504" data-mp="1nytgtnqdthu8" />

        <div className="grid gap-8 px-6 py-14 sm:px-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:items-center lg:py-16" data-id="element-2505" data-mp="1j60et7masnlu">
          <h2 className="text-h1 font-bold leading-[1.08] tracking-tight text-white" data-id="element-2506" data-mp="41dua4t05j1r">
            Your campus.
            <br data-id="element-2507" data-mp="3mfn3us5x8duy" />
            Your journey.
            <br data-id="element-2508" data-mp="3meli9tra48yz" />
            <span className="text-brand-200" data-id="element-2509" data-mp="3md0tylvk5m9k">One account.</span>
          </h2>

          <div className="max-w-md" data-id="element-2510" data-mp="3rc3tjqsrr0a5">
            <p className="text-body leading-relaxed text-white/80" data-id="element-2511" data-mp="3cgxiuqiqadah">
              Everything that matters to your campus life, connected in one place.
            </p>
            <div className="mt-6 flex flex-wrap items-center gap-3" data-id="element-2512" data-mp="3hdo03h69rexh">
              <Link to="/register" className="group inline-flex min-h-touch-lg items-center gap-2 rounded-lg bg-brand-600 px-6 text-body font-semibold text-white transition-colors duration-150 ease-out hover:bg-brand-500 hover:text-white" data-id="element-2513" data-mp="33har6wfswlum">
                Create your account
                <ArrowRightIcon aria-hidden className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-1" data-id="element-2514" data-mp="16lmsuuo9sv4d" />
              </Link>
              <Link to="/welcome/campuses" className="inline-flex min-h-touch-lg items-center gap-2 rounded-lg border border-white/35 bg-white/10 px-6 text-body font-semibold text-white transition-colors duration-150 ease-out hover:bg-white/20 hover:text-white" data-id="element-2515" data-mp="109jthclsd2ti">
                <ChevronRightIcon aria-hidden className="h-4 w-4" data-id="element-2516" data-mp="1ixymg5fnyqwy" />
                Explore Campuzon
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}